<template>
  <div class="consistenze">
    <table class="table-auto w-full text-xs">
      <thead class="bg-gray-200">
      <tr>
        <th class="text-left px-2 md:px-4">Descrizione</th>
        <th>Superficie</th>
        <th>Frazione</th>
        <th>Peso</th>
        <th class="text-right px-2 md:px-4">Superficie calcolata</th>
      </tr>
      </thead>
      <tbody>
      <consistenza v-for="(item, key) in consistenze" :consistenza="item" :key="key" />
      <consistenza :consistenze="consistenze" />
      </tbody>
    </table>
  </div>
</template>

<script>
import Consistenza from "@/components/Consistenza";
export default {
  name: "Consistenze",
  components: {Consistenza},
  props: ['consistenze'],
}
</script>

<style scoped>

</style>
